import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserStorage } from '@scisys-uim/uim-common';
import { TextSectionService } from 'assets-service';
import { BasePersistentTextSectionEntityComponent } from './base-persistent-text-section.component';

@Component({
  selector: 'persistent-simple-text-section-entity',
  templateUrl: './persistent-simple-text-section.component.html',
  styleUrls: ['./persistent-simple-text-section.component.scss']
})
export class PersistentSimpleTextSectionEntityComponent extends BasePersistentTextSectionEntityComponent {
  constructor(textSectionService: TextSectionService,
    userStorage: UserStorage,
    snackbar: MatSnackBar) {
    super(textSectionService, userStorage, snackbar);
  }
}
